import { Link } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { AlertTriangle, ChevronDown, LogOut, User, UserCircle } from 'lucide-react';
import { Breadcrumbs } from '../Breadcrumbs';

export function PortalHeader() {
    const { user, logout } = useAuth0();

    return (
        <header className="mx-auto w-full max-w-7xl px-6 pt-6">
            <div className="flex items-center justify-between gap-4">
                <Link to="/admin" className="flex min-w-0 items-center">
                    <div className="flex h-7 items-center gap-2.5">
                        <img
                            src="/Horizontal-FullColor-1.svg"
                            alt="WEVO"
                            className="-translate-y-0.5 h-6 w-auto shrink-0 object-contain object-left"
                            decoding="async"
                        />
                        <span className="h-5 w-px shrink-0 bg-neutral-200" aria-hidden="true" />
                        <span className="min-w-0 truncate text-base font-semibold leading-none tracking-wide text-[#767A83]">
                            Admin Portal
                        </span>
                    </div>
                </Link>

                <details className="relative z-50 shrink-0">
                    <summary className="flex cursor-pointer list-none items-center gap-2 rounded-full bg-transparent px-1 py-1 text-sm transition-colors hover:bg-neutral-100">
                        <div className="flex size-8 items-center justify-center rounded-full bg-[#276db0] text-white">
                            <User className="size-4" />
                        </div>
                        <div className="hidden text-left md:block">
                            <p className="max-w-44 truncate text-sm font-medium text-neutral-900">
                                {user?.name || user?.email || 'User'}
                            </p>
                            <p className="max-w-44 truncate text-xs text-neutral-500">
                                {user?.email}
                            </p>
                        </div>
                        <ChevronDown className="size-4 text-neutral-500" />
                    </summary>
                    <div className="absolute right-0 z-50 mt-2 w-64 rounded-lg border bg-white p-2 shadow-lg">
                        <div className="px-3 py-2">
                            <p className="truncate text-sm font-medium text-neutral-900">
                                {user?.name || 'Signed in user'}
                            </p>
                            <p className="truncate text-xs text-neutral-500">{user?.email}</p>
                        </div>
                        <div className="my-1 h-px bg-neutral-100" />
                        <Link
                            to="/profile"
                            className="flex items-center gap-2 rounded-md px-3 py-2 text-sm text-neutral-700 hover:bg-neutral-50"
                        >
                            <UserCircle className="size-4" />
                            Profile
                        </Link>
                        <Link
                            to="/admin/attention"
                            className="flex items-center gap-2 rounded-md px-3 py-2 text-sm text-neutral-700 hover:bg-neutral-50"
                        >
                            <AlertTriangle className="size-4" />
                            Attention Center
                        </Link>
                        <button
                            type="button"
                            onClick={() =>
                                logout({
                                    logoutParams: { returnTo: window.location.origin },
                                })
                            }
                            className="flex w-full items-center gap-2 rounded-md px-3 py-2 text-left text-sm text-neutral-700 hover:bg-neutral-50"
                        >
                            <LogOut className="size-4" />
                            Sign out
                        </button>
                    </div>
                </details>
            </div>
            <Breadcrumbs />
        </header>
    );
}
